import { Action } from '@ngrx/store';

export enum ReportsActionTypes {
  INIT_REPORTS_DATA = '[Cyclops Reports] Init Reports Wall',
  SET_CONTEXT_DATA = '[Cyclops Reports] Set Context Data',
  RESET_STATE = '[Cyclops Reports] Reset State',
}
export class ResetState implements Action {
  readonly type = ReportsActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitReportsTab implements Action {
  readonly type = ReportsActionTypes.INIT_REPORTS_DATA;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = ReportsActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export type CyclopsReportsActionUnion =
  | ResetState
  | InitReportsTab
  | SetContextData;
